var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRocketLaunch = function SvgRocketLaunch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.702,
    cy: 82.449,
    rx: 82.298,
    ry: 82.449,
    fill: "#FFE0E9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 165,
    height: 165
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.298,
    cy: 82.551,
    rx: 82.298,
    ry: 82.449,
    fill: "#FFE0E9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.757 127.077l78.948-49.565 5.263 5.273-51.58 77.512-32.631-33.22z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.669 76.265c-7.161-6.816-7.836-25.971 9.522-44.208 12.062-12.673 37.95-15.761 48.257-16.498-.227 10.33-2.034 36.34-14.096 49.013C112.995 82.808 93.83 83.08 86.669 76.264zM61.321 56.101A276.087 276.087 0 0177.783 32.75a61.676 61.676 0 0113.906-2.072 54.574 54.574 0 00-12.675 22.468 22.655 22.655 0 00-17.693 2.956zM72.993 75.086l5.47-5.747a23.906 23.906 0 001.527 4.614l-3.892 4.089-3.105-2.956zM77.801 85.581a2.146 2.146 0 01-.075-3.03l4.547-4.777a14.11 14.11 0 003.106 2.955l-4.547 4.778a2.146 2.146 0 01-3.03.074zM88.521 89.866l-3.106-2.956 3.892-4.09a23.906 23.906 0 004.684 1.299l-5.47 5.747zM108.06 100.586a22.651 22.651 0 002.078-17.818A54.575 54.575 0 00131.954 69a61.66 61.66 0 01-1.383 13.992 276.157 276.157 0 01-22.511 17.595z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.448 15.559c-1.088.078-2.381.19-3.782.328-1.092 12.323-4.296 29.925-13.568 39.667-17.358 18.237-36.523 18.509-43.684 11.693-.47-.45-.901-.939-1.29-1.46a16.98 16.98 0 004.545 10.478c7.161 6.815 26.326 6.544 43.684-11.693 12.062-12.673 13.868-38.683 14.095-49.013z",
    fill: "#FFE0E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.029 42.477c4.081-4.287 10.866-4.455 15.153-.374 4.288 4.081 4.456 10.866.375 15.154s-10.866 4.455-15.154.374-4.455-10.866-.374-15.154zm3.106 2.957a6.43 6.43 0 109.317 8.867 6.43 6.43 0 10-9.317-8.867z",
    fill: "#FC628F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.051 32.786a2.144 2.144 0 102.956-3.106 2.144 2.144 0 00-2.956 3.106z",
    fill: "#FC628F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.305 64.092c13.616-18.661 12.437-53.045 12.437-53.045s-34.4.52-52.366 15.04c-7.495.404-19.493 1.38-21.475 3.463-3.695 3.882-25.547 34.874-23.348 36.968 1.131-.028 3.18-1.341 5.771-3.002 5.656-3.626 13.897-8.909 20.818-6.095a35.398 35.398 0 00-.376 6.431l-7.879 8.278a4.287 4.287 0 00.15 6.062l3.39 3.227a6.395 6.395 0 008.747 8.325l3.391 3.227a4.287 4.287 0 006.061-.15l7.88-8.278a35.398 35.398 0 006.405-.692c3.152 6.774-1.718 15.265-5.06 21.093-1.531 2.67-2.742 4.781-2.714 5.912 2.2 2.094 32.075-21.262 35.77-25.144 1.983-2.083 2.366-14.115 2.398-21.62zm-74.984-7.99a276.085 276.085 0 0116.462-23.353 61.67 61.67 0 0113.906-2.072 54.575 54.575 0 00-12.675 22.468 22.655 22.655 0 00-17.693 2.956zm17.142 13.237l-5.47 5.747 3.105 2.956 3.892-4.089a23.906 23.906 0 01-1.527-4.614zM77.8 85.581a2.146 2.146 0 01-.074-3.03l4.546-4.777a14.104 14.104 0 003.106 2.956l-4.547 4.776a2.146 2.146 0 01-3.03.075zm7.614 1.329l3.106 2.956 5.47-5.748a23.9 23.9 0 01-4.684-1.297l-3.892 4.089zm1.254-10.645c-7.161-6.816-7.836-25.971 9.522-44.208 12.062-12.673 37.95-15.761 48.257-16.498-.227 10.33-2.034 36.34-14.096 49.013C112.995 82.808 93.83 83.08 86.669 76.263zm23.469 6.503a22.651 22.651 0 01-2.078 17.818 276.18 276.18 0 0022.511-17.595A61.773 61.773 0 00131.954 69a54.575 54.575 0 01-21.816 13.77z",
    fill: "#FC628F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h165v165H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRocketLaunch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocket-launch.25ffd45ad606b983149de38b8214a372.svg";